<ng-template #commentBody>

    <div [formGroup]="form">

        <ng-container *ngIf="!disabledPublicComment">

            <kal-form-field *ngIf="isPublicCommentDisplayed; else addPublic">

                <kal-textarea [label]="publicCommentLabel"
                              formControlName="publicComment"
                              id="comment_edit_public_comment_body">
                </kal-textarea>

                <a (click)="openConfirmClearDialog('publicComment')"
                   class="gup-O-link -secondary"
                   id="comment_edit_public_comment_delete">
                    Effacer
                </a>

            </kal-form-field>

        </ng-container>

        <ng-container *ngIf="!disabledPrivateComment">

            <kal-form-field *ngIf="isPrivateCommentDisplayed; else addPrivate">

                <kal-textarea [label]="privateCommentLabel"
                              formControlName="privateComment"
                              id="comment_edit_private_comment_body">
                </kal-textarea>

                <a (click)="openConfirmClearDialog('privateComment')"
                   class="gup-O-link -secondary"
                   id="comment_edit_private_comment_delete">
                    Effacer
                </a>

            </kal-form-field>

        </ng-container>

    </div>

</ng-template>

<ng-template #addPublic>
    <div>
        <a (click)="displayComment(CommentType.Public)"
           class="gup-C-moreInfos gup-O-link"
           id="comment_edit_comment_add_public">

            <kal-icon>add</kal-icon>
            Ajouter un&nbsp;<span>{{ publicCommentLabel }}</span>
        </a>
    </div>
</ng-template>

<ng-template #addPrivate>
    <div>
        <a (click)="displayComment(CommentType.Private)"
           class="gup-C-moreInfos gup-O-link"
           id="comment_edit_comment_add_private">

            <kal-icon>add</kal-icon>
            Ajouter un&nbsp;<span>{{ privateCommentLabel }}</span>
        </a>
    </div>
</ng-template>

<div *ngIf="!areCommentsDisplayed; else commentBody">
    <a (click)="displayAllComments()"
       class="gup-C-moreInfos gup-O-link"
       i18n id="comment_edit_comment_add">
        <kal-icon>add</kal-icon>
        Ajouter&nbsp;{commentQuantity, plural, one {un commentaire} other {des commentaires}}
    </a>
</div>

